import src from "IMAGE";
export default { src, width: 280, height: 180, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAASUlEQVR42o3MMQrAIBBE0W1CCEnukCiCrZWllxE9gkfw2n5ha3HgwRY7I7KREw8iEm68uHDMB4+Mhq53RYERbfwIumLxwenyOgNq6wSVdLDm5wAAAABJRU5ErkJggg=="};
